export default "__VITE_ASSET__CqaLt8aO__"